import React, { memo, useState } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import { AVALIACAO_SESSOES_QUESTOES } from '../../../enums';
import QuestaoCardTipo from '../_components/QuestaoCardTipo';

const AvaliacoesGestorEditQuestoes = memo(props => {
  const {
    sessoes = {},
    activeCategoryId,
    respostas = {},
    onQuestionChange,
    mostrarApenasNaoRespondidas = false
  } = props;

  const xQuestoesCategoria = AVALIACAO_SESSOES_QUESTOES[activeCategoryId];
  const xQuestoesExibidas = mostrarApenasNaoRespondidas
    ? (xQuestoesCategoria?.questoes || []).filter(pQuestao => !respostas[pQuestao.id]?.resposta_id)
    : xQuestoesCategoria?.questoes || [];

  const [selectedIndex, setSelectedIndex] = useState(1);

  const handleListItemClick = (pEvent, pIndex) => {
    setSelectedIndex(pIndex);
  };

  if (validators.isEmpty(activeCategoryId)) {
    return null;
  }

  return (
    <Stack gap={2}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase' }}>
            Sessão {`${sessoes[activeCategoryId].sessao}`}
          </Typography>
        </Stack>
        <Typography variant="h5" color="textPrimary">
          {sessoes[activeCategoryId].label}
        </Typography>
      </Stack>
      <Stack gap={3} pt={2}>
        {xQuestoesExibidas.map((xQuestao, xIndex) => {
            return (
              <QuestaoCardTipo
                key={crypto.randomUUID()}
                index={xIndex}
                data={xQuestao}
                value={respostas[xQuestao.id]?.resposta_id ?? ''}
                resposta={respostas[xQuestao.id] || {}}
                onChange={onQuestionChange}
              />
            );
          })}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesGestorEditQuestoes;
